// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>6</span>&nbsp;&nbsp;The words of the Lord are pure words,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;like silver refined in the furnace<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;and purified seven times in the fire.<br> </p> </div></div>";
// Exports
module.exports = code;